import CrudTable from "../../components/CrudTable";

const nameValidate = (v, f, items, editId) => {
  if (!String(v || "").trim()) return "Tanım zorunludur";
  if (items.some((i) => i.id !== editId && (i.name || "").trim().toLocaleLowerCase("tr") === String(v).trim().toLocaleLowerCase("tr"))) return "Bu tanım zaten kayıtlı";
  return "";
};
const rateValidate = (v) => {
  const n = parseFloat(String(v).replace(",", "."));
  if (isNaN(n)) return "Geçerli bir oran girin";
  if (n < 0 || n > 100) return "Oran 0-100 arasında olmalı";
  return "";
};

const KDV_DEFAULTS = { name: "", rate: "" };
const KDV_COLUMNS = [
  { key: "name", label: "Tanım" },
  { key: "rate", label: "Oran (%)", align: "right", render: (it) => `%${it.rate}` },
];
const KDV_FIELDS = [
  { key: "name", label: "Tanım", type: "text", validate: nameValidate },
  { key: "rate", label: "Oran (%)", type: "number", validate: rateValidate },
];

export default function KdvRates() {
  return <CrudTable resource="kdv-rates" title="" subtitle="" testidPrefix="kdv" defaults={KDV_DEFAULTS} columns={KDV_COLUMNS} fields={KDV_FIELDS} />;
}
